export var isAddBasketOfferPurschaseEvent = function (event) { return Boolean(event.detail.items); };
